import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';
import useFormState from '../../FormStateHelper';
import { validateForm } from '../../../selectors/defaultSelectors';
import FieldSelect from '../../fields/FieldSelect';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../../lang/main';
import { capitalize } from '../../../selectors/converterSelector';

const FORM_LABEL = {
    StripeCountryCode: getTranslation('FIELD.COUNTRY'),
    StripeCurrencyCode: getTranslation('FIELD.CURRENCY'),
};

function StripeCountryForm(props) {
    const { initialized, userInfo, handleFormSubmission, isLoading, requestStripeMissingFields } = props;
    const isFieldLoading = isLoading.basicInfo || false;
    const {
        formData,
        bindUpdateFormData,
        updateFormData,
        isSubmitting,
        submitForm,
    } = useFormState({
        handleFormSubmission: handleFormSubmission,
        initialFormState: {},
    });
    const [isValidated, setIsValidated] = useState(false);
    let fieldRefs = {};

    const finalFormData = {
        ...userInfo.basicInfo,
        ...formData,
    };

    const userStripeCountryCode = userInfo.basicInfo.StripeCountryCode || '';

    // Available Stripe Countries
    const availableStripeCountries = [
        {
            label: getTranslation('STRIPE_CONNECT_FORM.SELECT_COUNTRY'),
            value: '',
            currencies: [],
        }
    ];

    if(window.availableCountries) {
        window.availableCountries.forEach(item => {
            availableStripeCountries.push({
                label: item.title,
                value: item.code,
                currencies: item.currencies,
            });
        });
    }

    // Available Stripe Currencies
    let availableStripeCurrencies = [
        {
            label: getTranslation('STRIPE_CONNECT_FORM.SELECT_CURRENCY'),
            value: '',
        }
    ];

    if(window.availableCountries) {
        const userSelectedCountry = finalFormData.StripeCountryCode;

        if(userSelectedCountry) {
            const selectedStripeCountry = availableStripeCountries.find(item => item.value === userSelectedCountry);

            if(selectedStripeCountry) {
                availableStripeCurrencies = [...availableStripeCurrencies, ...selectedStripeCountry.currencies.map(item => {
                    return {
                        label: item,
                        value: item,
                    };
                })];
            }
        }
    }

    const onFormSubmit = (e) => {
        e.preventDefault();

        const submittedData = {
            StripeCountryCode: finalFormData.StripeCountryCode,
            StripeCurrencyCode: finalFormData.StripeCurrencyCode,
        };

        submitForm(submittedData, {
            success: (response) => {
                // Do something?
            },
        });
    };

    const onFieldUpdate = (e) => {
        bindUpdateFormData(e);
    };

    // Effects
    // --------------------
    // - Request fields
    useEffect(() => {
        if(userStripeCountryCode != '') {
            requestStripeMissingFields();
        }
    }, [userStripeCountryCode]);

    // - Validate form
    useEffect(() => {
        setIsValidated(!validateForm(fieldRefs));
    }, [finalFormData]);

    // - Request fields
    useEffect(() => {
        updateFormData('StripeCurrencyCode', '');
    }, [finalFormData.StripeCountryCode]);

    return (
        <React.Fragment>
            <div className="boxed-message boxed-message--yellow">
                <div className="boxed-message__header">
                    <span className="boxed-message__header-icon__holder">
                        <span className="boxed-message__header-icon">
                            <span className="icon icon-warning"></span>
                        </span>
                    </span>
                    <div className="row">
                        <div className="col-xs-12 col-md-7">
                            <h3 className="heading heading--lv4">
                                <LocalizedMessage id={'STRIPE_COUNTRY_FORM.HEADING'} />
                            </h3>
                            <h4 className="heading heading--lv5">
                                <LocalizedMessage id={'STRIPE_COUNTRY_FORM.SUBHEADING'} />
                            </h4>
                            <div className="vspace vspace--small">
                                <div className="text-box">
                                    <p>
                                        <LocalizedMessage id={'STRIPE_COUNTRY_FORM.CONTENT'} />
                                    </p>
                                </div>
                            </div>
                            <form className='form' onSubmit={onFormSubmit}>
                                <div className="row">
                                    <div className='col-xs-12 col-md-7 vspace vspace--small'>
                                        <FieldSelect
                                            ref={(r) => (fieldRefs.StripeCountryCode = r)}
                                            isLoading={isFieldLoading}
                                            label={FORM_LABEL['StripeCountryCode']}
                                            animatedLabel={FORM_LABEL['StripeCountryCode']}
                                            name='StripeCountryCode'
                                            options={availableStripeCountries}
                                            value={finalFormData.StripeCountryCode || ''}
                                            onChange={onFieldUpdate}
                                            required
                                        />
                                        <FieldSelect
                                            ref={(r) => (fieldRefs.StripeCurrencyCode = r)}
                                            isLoading={isFieldLoading}
                                            label={FORM_LABEL['StripeCurrencyCode']}
                                            animatedLabel={FORM_LABEL['StripeCurrencyCode']}
                                            name='StripeCurrencyCode'
                                            options={availableStripeCurrencies}
                                            value={finalFormData.StripeCurrencyCode || ''}
                                            onChange={onFieldUpdate}
                                            required
                                        />

                                        <button
                                            type='submit'
                                            className={`form__submit button ${!isValidated ? 'button--disabled' : ''}`}
                                            disabled={!isValidated}
                                        >
                                            <span style={{ opacity: isSubmitting === true ? 0 : 1 }}>
                                                <LocalizedMessage id={'SAVE_AND_CONTINUE'} />
                                            </span>
                                            {isSubmitting === true && (
                                                <ReactLoading
                                                    className='button__spinner'
                                                    type='spin'
                                                    color='white'
                                                    height={20}
                                                    width={20}
                                                />
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default StripeCountryForm;
